import { useContext, useCallback } from 'react';
import _isNil from 'lodash/isNil';
import _isNaN from 'lodash/isNaN';
import _isEmpty from 'lodash/isEmpty';

import { AjaxContext, AppContext, UserContext } from 'commons-ui';
import { UserDetailsContext } from 'context/userDetails';
import { USER_PROFILE_RESOURCES, PAGE_NAMES } from 'constant';
import { NOT_AVAILABLE } from '../constants';

const useService = () => {
	const {
		app: { appName }
	} = useContext(AppContext);
	const { postData } = useContext(AjaxContext);
	const {
		selectedUser: { uid }
	} = useContext(UserDetailsContext);

	const { user } = useContext(UserContext);

	const createTournamentRefundRequest = useCallback(async (reqParams: any) => {
		const result = await postData({
			endpoint: `/dashboard/createTournamentRefundRequest/${PAGE_NAMES.userProfile}-${USER_PROFILE_RESOURCES.gameplay}-createTournamentRefundRequest`,
			queryParams: {
				appName
			},
			body: {
				zupeeUserId: uid,
				gameName: reqParams.gameName,
				tournamentId: reqParams.ltid,
				transactionId: reqParams.transactionId,
				refundReason: reqParams.refundReason,
				tournamentStartTime: reqParams.tournamentStartTimeInMS,
				entryFee: reqParams.entryFee,
				freshdeskTicketId: reqParams.freshdeskTicketId,
				requesterEmailId: user?.email,
				refundSuggestionResult: reqParams.refund || NOT_AVAILABLE,
				refundSuggestionReason: reqParams.reason || NOT_AVAILABLE,
				leniencyResult: reqParams.leniencyResult || { isLenientRefund: false },
				...(!_isNil(reqParams.jiraTicketId) && !_isEmpty(reqParams.jiraTicketId)
					? { jiraTicketId: reqParams.jiraTicketId }
					: {}),
				...(!_isNil(reqParams.playingAttempt) && !_isNaN(reqParams.playingAttempt) && reqParams.playingAttempt !== 'undefined'
					? { playingAttempt: reqParams.playingAttempt }
					: {})
			}
		});

		return result;
	}, []);

	return {
		createTournamentRefundRequest
	};
};

export default useService;
